import $ from 'jquery';

if ($.fn.modal) {
  $.fn.modal.Constructor.prototype.enforceFocus = () => {
    // Nothing
  };
}

// Handle new modal event like a bootstrap event
$(document).on('aha-modal-header:close', event => {
  $(event.target).closest('.modal').modal('hide');
});

// Pass in a DOM element and this will round the values in any CSS transform
// matrix. For example <div style="transform: matrix(1, 2.2)>"
// would round the 2.2 to 2.
function roundCssTransformMatrix(elem) {
  const styles = window.getComputedStyle(elem, null); // gets the current computed style
  const transform =
    styles.getPropertyValue('-webkit-transform') ||
    styles.getPropertyValue('-moz-transform') ||
    styles.getPropertyValue('-ms-transform') ||
    styles.getPropertyValue('-o-transform') ||
    styles.getPropertyValue('transform') ||
    false;

  if (!transform) {
    return;
  }

  const values = transform.replace(/ |\(|\)|matrix/g, '').split(',');
  for (let v in values) {
    values[v] = Math.round(values[v]);
  }

  elem.style.transform = `matrix(${values.join()})`;
}

export { roundCssTransformMatrix };
